<template>
  <div class="footer-container">
    <el-divider></el-divider>

    <!-- 友情链接部分 -->
    <div class="friend-links">
      <h3>友情链接</h3>
      <div class="links">
        <a
          v-for="(link, index) in friendLinks"
          :key="index"
          :href="link.url"
          target="_blank"
          class="link-item"
        >
          {{ link.name }}
        </a>
      </div>
    </div>

    <!-- 备案信息部分 -->
    <div class="record-info">
      <p>Copyright © {{ currentYear }} 河南郑大水利科技有限公司 版权所有</p>
      <p>地址：河南省郑州市高新长椿路与翠竹街交叉口东北角2号楼217室</p>
      <div
        style="height: 32px; display: flex; justify-content: center; gap: 10px; margin-top: -15px"
      >
        <p>
          <a href="https://beian.miit.gov.cn/" target="_blank" class="record-link">
            {{ icpNumber }}
          </a>
        </p>
        <p>
          <img
            src="@/assets/record2.png"
            alt="备案图标"
            style="vertical-align: middle; margin-right: 3px; width: 16px; height: 16px"
          />
          <a
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=41019702002775"
            target="_blank"
            class="record-link"
          >
            {{ recordNumber }}
          </a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'SiteFooter',
    data() {
      return {
        currentYear: new Date().getFullYear(),
        recordNumber: '豫公网安备41019702002775号',
        icpNumber: '豫ICP备20019766号',
        friendLinks: [
          { name: '河南省水利厅', url: 'https://slt.henan.gov.cn/' },
          { name: '河南省科技厅', url: 'https://kjt.henan.gov.cn/' },
          { name: '郑州大学', url: 'https://www.zzu.edu.cn/' },
          { name: '郑大科技园', url: 'https://www7.zzu.edu.cn/nsp/index.htm' }
        ]
      }
    }
  }
</script>

<style scoped>
  .footer-container {
    padding: 0;
    text-align: center;
    color: #666;
    font-size: 14px;
    background-color: #ededed;
  }

  .friend-links {
    margin-bottom: 8px;
    /* background-color: aqua; */
  }

  .friend-links h3 {
    margin-bottom: 8px;
    color: #333;
  }

  .links {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }

  .link-item {
    margin: 0 10px;
    color: #666;
    text-decoration: none;
    transition: color 0.3s;
  }

  .link-item:hover {
    color: #409eff;
  }

  .record-info {
    line-height: 1;
    padding-bottom: 1px;
  }

  .record-link {
    color: #666;
    text-decoration: none;
  }

  .record-link:hover {
    color: #409eff;
  }

  .el-divider {
    margin: 0 0 10px 0;
  }
</style>
